export const ORIGEM = new URLSearchParams(window.location.search).get("o")
const isDC = ORIGEM != 'pp';

export default isDC;